import React from 'react'

// material ui
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

// components
import LimitedAvailabilityModal from './LimitedAvailabilityModal'

// decorators
import { restrictedRanges } from 'lib/cart/decorators/softClose'

const SoftCloseNotice = props => {
  const { location, session, plan, acknowledged, onAcknowledge } = props

  const [modalOpen, setModalOpen] = React.useState(false)

  const restricted = restrictedRanges(location, plan)

  return (
    <Alert severity='warning' sx={{ mt: 2 }}>
      <AlertTitle>Limited availability at {location.name}</AlertTitle>

      <Typography variant='body2' gutterBottom>
        Due to high demand, {location.name} has reached capacity on select
        dates. Your Passes cannot be used in {location.name} during the
        following dates: <strong>{restricted.join(', ')}</strong>.
      </Typography>

      <Typography variant='body2' gutterBottom>
        For a complete list of additional locations and dates with limited
        availability,{' '}
        <Link component='button' onClick={() => setModalOpen(true)}>
          click here
        </Link>
        .
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            name='acknowledge-soft-close'
            checked={!!acknowledged}
            onChange={e => onAcknowledge(e.target.checked)}
          />
        }
        label='I understand my day passes are not valid on the dates listed above.'
      />

      <LimitedAvailabilityModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        session={session}
        plan={plan}
      />
    </Alert>
  )
}

export default SoftCloseNotice
